import { defineComponent as _defineComponent } from 'vue'
import { computed } from "vue";
import { renderSafeMarkdown } from "@/utils/safeMarkdown";


export default /*#__PURE__*/_defineComponent({
  __name: 'SafeMarkdown',
  props: {
    source: { default: "" }
  },
  setup(__props: any) {

const props = __props as { source: string | null };



const renderedHtml = computed(() => renderSafeMarkdown(props.source || ""));

return { __sfc: true,props, renderedHtml }
}

})